export default __webpack_public_path__ + "static/media/IMG_9310.f9d7faab.JPG";